import { Injectable, OnInit } from '@angular/core';
import { LangLaib, ILanguagePaging } from '../models/languages'
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class LanguageService implements OnInit {
    private availableLanguages: Array<any> = ["ita", "eng"]
    private static usedLanguage: BehaviorSubject<string> = new BehaviorSubject("ita");
    private static Dictionary: BehaviorSubject<ILanguagePaging> = new BehaviorSubject(LangLaib["ita"]);
    private static Pages: Array<BehaviorSubject<any>> = [];
    private static Alerts: BehaviorSubject<any> = new BehaviorSubject({})
    constructor() { }

    ngOnInit() { }

    getUsedLanguage() {
        return LanguageService.usedLanguage.asObservable();
    }
    getAvailableLanguages(): Array<any> {
        return this.availableLanguages;
    }
    setLanguage(lang: string) {
        if (this.availableLanguages.indexOf(lang) == -1)
            lang = "ita"
        document.documentElement.setAttribute('lang', lang.slice(0,2));
        if (LanguageService.usedLanguage.getValue() != lang)
            LanguageService.usedLanguage.next(lang)
        LanguageService.Dictionary.next(LangLaib[lang]);
        var Dictionary = LanguageService.Dictionary.getValue();
        for (var index = 0; index < Dictionary.numOfPages; index++) {
            if (LanguageService.Pages[index] == undefined) {
                LanguageService.Pages[index] = new BehaviorSubject<any>({});
            }
            var data = Dictionary.pages[index];
            var common = Dictionary.common;
            LanguageService.Pages[index].next({ ...data, ...common });

        }
        LanguageService.Alerts.next(Dictionary.alerts);
        return true;
    }

    translatePageIndex(index: number): Observable<any> {
        if (LanguageService.Dictionary.getValue().numOfPages > index) {
            return LanguageService.Pages[index].asObservable();
        }
        else
            return null;
    }
    subscribeAlerts(): Observable<any> {
        return LanguageService.Alerts.asObservable();
    }

}





// WEBPACK FOOTER //
// ./src/app/theme/services/language.service.ts